import Library from '../utility/Library';
import Entity from './Entity';
import Status from './Status';
import Reader from './blueprint/Reader';
import User from '../../User';

export default class Enemy extends Entity {

	constructor (master, model, slot, no) {

		super();
		master.register(this, "enemy", no);
		this.slot = slot;
		this.model = Library.getUpgradedEnemy(model, master.run.difficultySetting);
		User.learn("enemies", this.model.key);
		this.maxhp = Math.floor(Math.random() * (this.model.hp[1] - this.model.hp[0] + 1)) + this.model.hp[0];
		this.hp = this.maxhp;
		this.block = this.model.block;
		//this.drops = this.model.drops.map(drop => Object.assign({}, drop));
		// Snapshot health for the view. The enemy object remains mutable while
		// notifications are sequenced, so a newly spawned enemy can be damaged
		// before its newenemy notification is reduced.
		master.notify('newenemy', this, master, model, slot, this.hp, this.maxhp);

		this.setupPatterns();
	}

	init () {

		if (this.stance.states)
			this.stance.states.forEach(state => this.apply(state.key, state.value));
	}

	get key () { return this.id.no; }

	get alive () { return this.hp > 0 }
	get dead () { return this.hp <= 0 }

	get intent () { return this.nointent !== null && this.nointent !== undefined ? this.patterns[this.nointent] : null; }

	get stance () { return this.nostance === undefined ? this.model : this.model.stances[this.nostance] }

	get img () { return this.stance.img }

	get passive () { return this.stance.passive }

	get isEnemy () { return true; }

	die () {

		if (this.removed)
			return;

		const splitCount = this.getStatusValue("split");
		const splitModel = this.model.split;
		const splitSlot = this.slot;
		super.die();
		// Some death triggers (such as Pile of bones) switch the enemy to a
		// passive stance so it can remain in the fight and revive later.
		if (!this.passive) {
			this.removed = true;
			this.master.removeEnemy(this);
			this.master.notify('enemydie', this);
			if (splitCount > 0 && splitModel) {
				for (let i = 0; i < splitCount; i++)
					this.master.spawnEnemy(splitModel, i === 0 ? splitSlot : undefined);
			}
		}
		//this.drops.forEach(drop => this.master.addLoot(drop));
		if (this.master.requiredEnemies.length <= 0)
			this.master.win();
	}

	getRandomIndex(arr) {
	    // Créer le tableau cumulatif des probabilités
	    const cumulativeSum = [];
	    let sum = 0;
	    for (let i = 0; i < arr.length; i++) {
	        sum += arr[i];
	        cumulativeSum.push(sum);
	    }

	    // Générer un nombre aléatoire entre 0 et la somme totale des valeurs
	    const randomValue = Math.random() * sum;

	    // Trouver l'index correspondant
	    let i = 0;
	    while (cumulativeSum[i] < randomValue)
	    	i++;

	    return i;
	}

	haveIntent () {

		if (!this.patterns)
			return null;

		this.nointent = this.patterns.findIndex(p => p.cycle && this.master.turncount % p.cycle === 0);
		if (this.nointent === -1)
			this.nointent = this.getRandomIndex(this.previousintent !== null && this.previousintent !== undefined ? this.patterns[this.previousintent].next : this.stance.starter);
		this.previousintent = this.nointent;
		this.master.notify('intent', this, this.nointent);
		return this.intent;
	}

	loseIntent () {

		this.nointent = null;
		this.master.notify('intent', this, this.nointent);
	}

	act () {

		if (this.intent) {
			let intent = this.intent;
			this.master.notify('enemyact.before', this, intent.damage ? "attack" : "status");
			intent.act();
			this.master.notify('enemyact', this, intent.damage ? "attack" : "status");
			delete this.nointent;
		}
	}

	setupPatterns () {

		delete this.patterns;
		if (this.stance.patterns) {
			this.patterns = this.stance.patterns.map(pattern => Object.assign({}, pattern));
			this.patterns.forEach((pattern,i) => {
				if (!pattern.blueprint) {
					pattern.act = () => {};
					return;
				}
				this.computecode = i;
				pattern.blueprint = Reader.read(pattern.blueprint, this);
				delete this.computecode;
				let e = this.events[0];
				pattern.act = () => e();
				delete this.events;
			});
		}
	}

	switchStances (no, reset) {

		this.nostance = no < 0 ? undefined : no;
		this.nointent = null;
		delete this.previousintent;
		this.setupPatterns();

		if (reset) {
			this.statuses.forEach(status => {
				status.dissipate()
			});
			this.init();
		}

		this.master.notify('entitystance', this, no);
	}

	serialize () {

		return {
			key: this.key,
			model: this.model.key,
			maxhp: this.maxhp,
			hp: this.hp,
			block: this.block,
			//drops: this.drops.map(drop => Object.assign({}, drop)),
			statuses: this.statuses.map(status => status.serialize()),
			nointent: this.nointent,
			previousintent: this.previousintent,
			nostance: this.nostance,
			slot: this.slot
		}
	}

	static build (master, src) {

		let enemy = new Enemy(master, src.model, src.slot, src.key);
		enemy.maxhp = src.maxhp;
		enemy.hp = src.hp;
		enemy.block = src.block;
		//enemy.drops = src.drops.map(drop => Object.assign({}, drop));
		enemy.statuses = src.statuses.map(status => Status.build(master, enemy, status));
		enemy.nointent = src.nointent;
		enemy.previousintent = src.previousintent;
		enemy.nostance = src.nostance;
		enemy.setupPatterns();
		return enemy;
	}
}
